import { Suspense, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Participant } from 'livekit-client';
import { useParticipant } from 'core';
import { useParticipantItem } from 'features/ParticipantItem';
import { RaiseHandListIcon } from 'features/RaiseHand/components';
import { ListIconWrapper, ListItemAvatar, ListItemUserInfo, WaitingUserItem, WaitingUserName } from './view';
import { ParticipantListAvatar } from './ParticipantListAvatar';

interface IProps {
    participant: Participant;
}

export const RaisedHandListItem = observer(({ participant }: IProps) => {
    const { isLocal } = useParticipant(participant);
    const { getDisplayData } = useParticipantItem();
    const { currentName, name, placeholder } = useMemo(
        () => getDisplayData(participant, isLocal),
        [participant, isLocal, getDisplayData],
    );

    return (
        <WaitingUserItem>
            <ListItemUserInfo>
                <ListItemAvatar sid={participant.sid}>
                    <Suspense fallback={placeholder}>
                        <ParticipantListAvatar participant={participant} name={name} placeholder={placeholder} />
                    </Suspense>
                </ListItemAvatar>
                <WaitingUserName>{currentName}</WaitingUserName>
            </ListItemUserInfo>
            <ListIconWrapper>
                <RaiseHandListIcon />
            </ListIconWrapper>
        </WaitingUserItem>
    );
});
